"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SpinCard = _interopRequireDefault(require("../SpinCard"));
const SpinCardWithSeparator = ({
  domain,
  index,
  selectedSpinIndex,
  onCardSpinClick,
  isRightSpinSelected,
  isLeftSpinSelected,
  ctaProps,
  options,
  enableDynamicFontScaling,
  PriceBlock,
  language,
  AddToCartButton,
  CustomCartStateBadge
}) => {
  const isSelected = selectedSpinIndex === index;
  const isClickable = options?.isClickable;
  const expandSpinOnAddToCart = () => {
    !isSelected && onCardSpinClick(index);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "spin-card-grid-container",
    key: `${domain?.Fqdn}_${index}`
  }, /*#__PURE__*/_react.default.createElement(_SpinCard.default, {
    customClassName: selectedSpinIndex === index && isClickable ? 'spin-card-grid-selected' : 'spin-card-grid',
    domain: domain,
    product: domain?.product,
    ctaProps: ctaProps,
    options: options,
    hideIcon: true,
    enableDynamicFontScaling: enableDynamicFontScaling,
    PriceBlock: PriceBlock,
    language: language,
    AddToCartButton: AddToCartButton,
    onClick: () => onCardSpinClick(index),
    CustomCartStateBadge: CustomCartStateBadge,
    expandSpinOnAddToCart: () => expandSpinOnAddToCart(index)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('spin-card-grid-separator-container', {
      'spin-card-grid-separator-container-selected': isSelected && isClickable
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'spin-card-grid-separator-border spin-card-grid-separator-right-border': !isRightSpinSelected && isSelected,
      'spin-card-grid-separator-border-selected': isSelected && isClickable
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'spin-card-grid-separator-border spin-card-grid-separator-left-border': !isLeftSpinSelected && isSelected,
      'spin-card-grid-separator-border-selected': isSelected && isClickable
    })
  })));
};
var _default = exports.default = SpinCardWithSeparator;